import { Link } from '@/i18n/navigation'

import { useHeaderContext } from './context/HeaderContext'

import { ButtonLabel, Paragraph } from '@/components/atoms/Typography'
import Container from '@/components/atoms/Container'
import Flex from '@/components/atoms/Flex'
import Icon from '@/components/atoms/Icon'

import styles from './Header.module.scss'

const PreHeader = () => {
  const { banner } = useHeaderContext()

  if (!banner) return <></>

  const { cta, has_cta, text } = banner
  return (
    <div className={styles.preHeader}>
      <Container>
        <Flex
          justifyContent='between'
          alignItems='center'
        >
          {has_cta && cta && (
            <Link
              className={styles.goToMain}
              href={cta.href}
              target={cta.target}
              rel={cta.rel}
            >
              <ButtonLabel
                size='sm'
                weight='medium'
              >
                <Flex
                  gap='0.5rem'
                  alignItems='center'
                >
                  <Icon iconName='ArrowLeft' />
                  {cta.label}
                </Flex>
              </ButtonLabel>
            </Link>
          )}

          {text && (
            <Paragraph
              size='xs'
              className={styles.ranking}
              content={text}
              dangerouslySetInnerHTML
            />
          )}
        </Flex>
      </Container>
    </div>
  )
}

export default PreHeader
